import {useQuery} from 'react-query';
import getStoreAndLabViews from '.';

const useGetStoreViews = () => {
  const {data, isLoading} = useQuery(['get-store-views'], () =>
    getStoreAndLabViews(),
  );

  return {data, isLoading};
};

export default useGetStoreViews;
